// @flow
import React from 'react';
import styled from 'styled-components';

import TextBlock from './TextBlock';

const NullStateLayout = styled.div`
  align-items: center;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;

  ${TextBlock} {
    margin-top: 8px;
  }
`;

const BigEmoji = styled.div`
  font-size: 80px;
  line-height: 120px;
`;

type NullStateProps = {
  bigEmoji: string,
  description?: string,
  title: string,
};

const NullState = ({ bigEmoji, description, title }: NullStateProps) => (
  <NullStateLayout>
    <BigEmoji>{bigEmoji}</BigEmoji>
    <TextBlock styleType="mediumBold">{title}</TextBlock>
    {description && <TextBlock>{description}</TextBlock>}
  </NullStateLayout>
);

NullState.defaultProps = {
  description: undefined,
};

export default NullState;
